import { useEffect, useState } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import TableTopBar from "./modal/tableTopBar";
import BarGraph from "../atom/Charts/BarGraph";
import DoughnutChart from "../atom/Charts/doughnutChart";
import {
  ExpandIcon,
  TableSortIconDownArrow,
  ThreeDotsIcon,
} from "../utils/icons/defaultIcons";
import Table from "../atom/table";
import CheckPermission from "../services/permission";
import { useSelector } from "react-redux";
import { dashboardRandomNumber } from "../services/utilities";

// const ResponsiveReactGridLayout = WidthProvider(Responsive);
const ResponsiveReactGridLayout = WidthProvider(
  Responsive
) as unknown as React.ComponentType<any>;

function Dashboard() {
  const permissions = useSelector(
    (state: any) => state.Permissions.permissions
  );
  // const [hideDropdownValues, setHideDropdownValues] = useState<any>([{ name: 'Extension', checked: false }, { name: 'First Name', checked: false }, { name: 'Last Name', checked: false }, { name: 'Allow Time Zone Restriction', checked: false }])
  const [drag, setDrag] = useState(true);
  const [widgetList, setWidgetList] = useState([
    {
      i: "0",
      name: " Queue Info",
      permission: "dashboard.queue_info.get",
      x: 0,
      y: 0,
      w: 4,
      h: 2,
      hidden: false,
    },
    {
      i: "1",
      name: "Incoming Statistics",
      permission: "dashboard.incoming_statistics.get",
      x: 1,
      y: 0,
      w: 1,
      h: 1,
      hidden: false,
      checked: false,
    },
    {
      i: "2",
      name: "Outgoing Statistics",
      permission: "dashboard.outgoing_statistics.get",

      x: 0,
      y: 1,
      w: 2,
      h: 1,
      hidden: false,
      checked: false,
    },
    {
      i: "3",
      name: "Todays Call Statistics",
      permission: "dashboard.today_call_statistics.get",

      x: 2,
      y: 0,
      w: 1,
      h: 1,
      hidden: false,
      checked: false,
    },
    {
      i: "4",
      name: "Top Callers",
      permission: "dashboard.top_callers.get",
      x: 3,
      y: 0,
      w: 1,
      h: 1,
      hidden: false,
      checked: false,
    },
    {
      i: "5",
      name: "Agent Status",
      permission: "dashboard.agent_status.get",
      x: 3,
      y: 0,
      w: 1,
      h: 1,
      hidden: false,
      checked: false,
    },
    {
      i: "6",
      name: "Call Report",
      permission: "dashboard.call_report.get",
      x: 3,
      y: 0,
      w: 1,
      h: 1,
      hidden: false,
      checked: false,
    },
  ]);
  const layoutData = {
    lg: [
      { x: 0, y: 0, w: 4, h: 2, i: "0" },
      { x: 0, y: 1, w: 2, h: 3, i: "1" },
      { x: 2, y: 1, w: 2, h: 3, i: "2" },
      { x: 0, y: 3, w: 4, h: 3, i: "3" },
      { x: 4, y: 0, w: 1, h: 3, i: "4" },
      { x: 4, y: 4, w: 1, h: 2, i: "5" },
      { x: 4, y: 5, w: 1, h: 3, i: "6" },
      // { x: 0, y: 2, w: 1, h: 1, i: "7" },
    ],
  };
  const [layouts, setLayouts] = useState<any>({ ...layoutData });

  useEffect(() => {
    widgetList.map((node: any) => {
      console.log("widgetList-map", widgetList, node, node.i);
      let tempLayout = { ...layouts };
      let randomIndex = dashboardRandomNumber(7);
      console.log("widgetList-map", widgetList, node, node.i);
      const layoutIndex = tempLayout.lg.findIndex(
        (item: any) => item.i === node.i
      );
      console.log("widgetList-map-index", layoutIndex);

      if (node.hidden && layoutIndex !== -1) {
        console.log("widgetList-REmoveinggggggg", layoutIndex, node.hidden);
        tempLayout.lg.splice(layoutIndex, 1);
        setLayouts({ ...tempLayout });
      } else if (!node.hidden && layoutIndex === -1) {
        console.log("widgetList-addingggg", [
          ...tempLayout.lg,
          layoutData.lg[node.i],
        ]);
        tempLayout.lg = [
          ...tempLayout.lg.slice(0, randomIndex),
          layoutData.lg[node.i],
          ...tempLayout.lg.slice(randomIndex),
        ];
        console.log("layoutstesst---test", tempLayout.lg);
        setLayouts({ ...tempLayout });
      }
      return null;
    });
  }, [widgetList]);

  const numbers: any = [];
  for (let i = 0; i <= 10; i++) {
    numbers.push(i * 10);
  }

  const [tableTitles, setTableTitles] = useState<any>([
    { key: "data1", title: "Extension", icon: <TableSortIconDownArrow /> },
    { key: "data2", title: "Name", icon: <TableSortIconDownArrow /> },
    { key: "data3", title: "Number", icon: <TableSortIconDownArrow /> },
  ]);

  const [tableData, setTableData] = useState<any>([
    { data1: "Inbound", data2: "120", data3: "102" },
    { data1: "Outbound", data2: "110", data3: "102" },
    { data1: "Outbound", data2: "102", data3: "102" },
    { data1: "Inbound", data2: "115", data3: "115" },
    { data1: "Outbound", data2: "115", data3: "115" },
    { data1: "Inbound", data2: "115", data3: "115" },
    { data1: "Outbound", data2: "115", data3: "110" },
    { data1: "Outbound", data2: "115", data3: "110" },
    { data1: "Inbound", data2: "115", data3: "115" },
    { data1: "Inbound", data2: "115", data3: "110" },
    { data1: "Outbound", data2: "115", data3: "115" },
  ]);

  const checkItem = (id: any) => {
    return (
      <div
        data-testid="dashboard"
        className="overflow-hidden w-full h-full px-2 py-2"
      >
        {id === "0" ? (
          <div>
            {/* Layout top stuffs */}
            <div className="flex justify-between">
              <div className="font-semibold ml-3">Queue Info</div>
              <div className="flex justify-center items-center gap-5 mr-3.5">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Kev Test</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
            {/*  */}
            <div className="grid grid-cols-6 py-1 ">
              {queueInfo?.map((node: any, index: number) => {
                return (
                  <div key={node} className="text-center mt-4">
                    <p className="flex justify-center">
                      <div className="w-[45px] h-[45px] bg-[#E6E9F7] flex justify-center items-center rounded-lg">
                        {node.icon}
                      </div>
                    </p>
                    <p className="font-extrabold  block mt-1">{node.number}</p>
                    <p className="text-[#888888] block mt-0 ">{node.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
        ) : id === "1" ? (
          <div className="h-full">
            {/* top */}
            <div className="flex justify-between">
              <div className="font-semibold">Incoming Statistics</div>
              <div className="flex justify-center items-center gap-5 mr-3.5">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Group</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Today</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
            {/*  */}
            <div className="w-full flex justify-between mt-2">
              <div>
                <p className="font-bold text-[20px]">50%</p>
                <p className="text-primary">Service Level</p>
              </div>
              <div className="flex gap-2 items-center">
                <div className="w-[30px] h-[30px] rounded-md bg-[#98A6DD]"></div>
                <div>Answered</div>
              </div>
            </div>
            <div className="w-[100%] h-[70px] bg-[#E6F9F4] rounded-lg flex items-center mt-3">
              <div className="w-[calc(50%-18px)] h-[58px] bg-[#98A6DD] ml-1.5 rounded-lg"></div>
            </div>
            <div className="flex justify-between w-[100%] mt-1">
              {numbers?.map((number: number) => (
                <p className="" key={number}>
                  {number}
                </p>
              ))}
            </div>
            <p className="w-[100%] text-center mt-1">Calls</p>
          </div>
        ) : id === "2" ? (
          <div className="h-full">
            {/* top */}
            <div className="flex justify-between">
              <div className="font-semibold">Outgoing Statistics</div>
              <div className="flex justify-center items-center gap-5 mr-3.5">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Group</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Today</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
            {/*  */}
            <div className="w-full flex justify-between mt-2">
              <div>
                <p className="font-bold text-[20px]">80%</p>
                <p className="text-primary">Service Level</p>
              </div>
              <div className="flex gap-2 items-center">
                <div className="w-[30px] h-[30px] rounded-md bg-[#DDBD9B]"></div>
                <div>Answered</div>
              </div>
            </div>
            <div className="w-[100%] h-[70px] bg-[#E6F9F4] rounded-lg flex items-center mt-3">
              <div className="w-[calc(80%-10px)] transition-all h-[58px] bg-[#DDBD9B] ml-1.5 rounded-lg"></div>
            </div>
            <div className="flex justify-between w-[100%] mt-1">
              {numbers?.map((number: number, index: number) => (
                <p className="" key={index}>
                  {number}
                </p>
              ))}
            </div>
            <p className="w-[100%] text-center mt-1">Calls</p>
          </div>
        ) : id == "3" ? (
          // <Holidays_widget />
          <div className="h-full">
            <div className="flex justify-between">
              <div className="font-semibold">Todays Call Statistics</div>
              <div className="flex justify-center items-center gap-5 mr-3.5">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Group</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
            <BarGraph
              labels={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
              label={"Calls"}
              set={5}
              data={datas.data}
              border={0}
              color={datas.color}
            />
          </div>
        ) : id === "4" ? (
          <div className="h-full no-scrollbar">
            <div className="flex justify-between">
              <div className="font-semibold">Top Callers</div>
              <div className="flex justify-center items-center gap-5 mr-3">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Today</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
            <div className="max-h-[350px] -mt-5">
              <Table
                tableTitles={tableTitles}
                tableData={tableData}
                setTableData={setTableData}
                setTableTitles={setTableTitles}
                width={"w-[calc(100vw-1600px)]"}
                scrollHeight={"max-h-[350px] overflow-y-auto"}
              />
            </div>
          </div>
        ) : id === "5" ? (
          <div className="h-full">
            <div className="flex justify-between">
              <div className="font-semibold">Agent Status</div>
              <div className="flex justify-center items-center gap-5 mr-3">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Today</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-3 py-1">
              {agentStatus?.map((node: any, index: number) => {
                return (
                  <div className="text-center mt-6">
                    <p className="flex justify-center">
                      <div className="w-[24px] h-[24px] bg-[#E6E9F7] flex justify-center items-center rounded-lg">
                        {node.icon}
                      </div>
                    </p>
                    <p className="font-extrabold  block mt-1">{node.number}</p>
                    <p className="text-[#888888] block mt-0 ">{node.name}</p>
                  </div>
                );
              })}
            </div>
          </div>
        ) : id === "6" ? (
          <div className="h-full ">
            <div className="flex justify-between">
              <div className="font-semibold">Call Report</div>
              <div className="flex justify-center items-center gap-5 mr-3">
                <div className="w-[120px] h-[20px] border border-[#898989] rounded-[5px] flex items-center justify-between cursor-pointer">
                  <a className="ml-2.5 text-[#767676] text-sm">Today</a>
                  <a className=" mr-4">
                    <TableSortIconDownArrow />
                  </a>
                </div>
                <div className="cursor-pointer">
                  <ExpandIcon />
                </div>
                <div className="cursor-pointer">
                  <ThreeDotsIcon />
                </div>
              </div>
            </div>
            <div className="h-[80%] flex justify-center relative mt-4">
              {/* <div className="ml-[18px] w-fit ">{datas1.status.map((node, index) => {

                                return <div className="flex items-center gap-1 p-1">

                                    <div style={{ backgroundColor: `${datas1?.color[index]}` }} className="w-2 h-6 p-1 text-sm rounded-[2px]"></div>

                                    <div className='flex flex-col'>

                                        <span className="text-[#505050] text-sm font-normal leading-normal">{node}</span>

                                        <span className='text-xs'>{datas1?.data[index]}</span>

                                    </div>

                                </div>

                            })}

                            </div> */}
              <div className="flex flex-col items-center justify-center rounded-full h-20 w-20 absolute top-[60px] left-25">
                {/* <div className='text-xl font-bold'>6</div> */}

                <div className="text-lg font-medium">Calls</div>
              </div>
              <DoughnutChart
                labels={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
                set={5}
                data={doughNutData.data}
                border={0}
                color={doughNutData.color}
              />
            </div>
          </div>
        ) : id === "7" ? (
          <div>
            <BarGraph
              labels={["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]}
              set={5}
              data={datas.data}
              border={0}
              color={datas.color}
            />
          </div>
        ) : null}
      </div>
    );
  };
  const generateDOM = () => {
    // const checkUserPermission = (keyParam: string) => {
    //   var sprd = keyParam.split(".");
    //   const filter = permissions[sprd[0]]?.find((node: any) => {
    //     console.log(node, "node");
    //     return node === keyParam;
    //   });
    //   console.log("fll", filter, keyParam);
    //   return filter ? true : false;
    // };
    return (
      // widgetList
      //   .filter((node: any) => {
      //     console.log(node.permission, "nodeeee");
      //     return node.hidden === false;
      //   })
      // return widgetList
      // .filter((node: any) => {
      //   console.log(node.permission, "nodeeee");
      //   return checkUserPermission(node.permission) && node.hidden === false;
      // })
      layouts.lg.map((l: any) => {
        return (
          <div
            key={l.i}
            className={` ${
              l.hidden === true ? "hidden" : "flex"
            } px-1 group bg-[#ffff]  h-full w-full relative shadow-lg rounded-xl overflow-hidden justify-center items-center gap-2`}
          >
            {checkItem(l.i)}
            <FadeIn>
              <div
                className={
                  drag === true
                    ? "drag-handle hidden group-hover:block absolute right-1 top-1 cursor-pointer text-white"
                    : "hidden"
                }
              >
                {/* <DragIcon /> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#000000"
                  viewBox="0 0 256 256"
                >
                  <path d="M90.34,61.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,43.31V96a8,8,0,0,1-16,0V43.31L101.66,61.66A8,8,0,0,1,90.34,61.66Zm64,132.68L136,212.69V160a8,8,0,0,0-16,0v52.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm83.32-72-32-32a8,8,0,0,0-11.32,11.32L212.69,120H160a8,8,0,0,0,0,16h52.69l-18.35,18.34a8,8,0,0,0,11.32,11.32l32-32A8,8,0,0,0,237.66,122.34ZM43.31,136H96a8,8,0,0,0,0-16H43.31l18.35-18.34A8,8,0,0,0,50.34,90.34l-32,32a8,8,0,0,0,0,11.32l32,32a8,8,0,0,0,11.32-11.32Z"></path>
                </svg>
              </div>
            </FadeIn>
          </div>
        );
      })
    );
  };
  const datas = {
    data: [15, 22, 18, 45, 32, 42],

    color: ["#3C91FF"],

    status: ["On time", "Critical", "Not Started", "Started", "Started"],

    label: [
      "Project Status",
      "Project Status",
      "Project Status",
      "Project Status",
    ],
  };
  const doughNutData = {
    data: [15, 22, 18, 45, 32, 42],

    color: ["#8192db", "#E6E9F7", "#5570eb", "#2E4BB9", "#98A6DD", "#6D81CE"],

    status: ["On time", "Critical", "Not Started", "Started", "Started"],

    label: [
      "Project Status",
      "Project Status",
      "Project Status",
      "Project Status",
    ],
  };

  const queueInfo = [
    {
      name: "Call Count",
      number: "17",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.8936 10.1416L10.5812 8.65728L10.572 8.65306C10.4001 8.57951 10.2125 8.55 10.0262 8.56718C9.83998 8.58437 9.66097 8.64772 9.50537 8.7515C9.48705 8.7636 9.46944 8.77675 9.45264 8.79087L7.74123 10.2499C6.65701 9.72322 5.53764 8.61228 5.011 7.54212L6.47209 5.8047C6.48615 5.78712 6.49951 5.76955 6.51217 5.75056C6.61372 5.59538 6.67533 5.41751 6.69153 5.23276C6.70772 5.04802 6.67799 4.86213 6.60498 4.69165V4.68322L5.11647 1.36517C5.01995 1.14247 4.85401 0.956946 4.64339 0.836307C4.43278 0.715667 4.1888 0.666377 3.94787 0.695795C2.99512 0.821167 2.12058 1.28907 1.48759 2.01211C0.854606 2.73515 0.506462 3.66389 0.508185 4.62486C0.508185 10.2077 5.05037 14.7499 10.6332 14.7499C11.5942 14.7516 12.5229 14.4034 13.2459 13.7705C13.969 13.1375 14.4369 12.2629 14.5622 11.3102C14.5917 11.0693 14.5425 10.8254 14.422 10.6148C14.3015 10.4042 14.1161 10.2382 13.8936 10.1416ZM10.6332 13.6249C8.24704 13.6223 5.95936 12.6732 4.2721 10.9859C2.58484 9.29868 1.63579 7.01101 1.63318 4.62486C1.63054 3.93825 1.87791 3.27415 2.32909 2.75659C2.78028 2.23903 3.40443 1.90339 4.08498 1.81236C4.0847 1.81516 4.0847 1.81799 4.08498 1.8208L5.56154 5.12548L4.10818 6.86501C4.09343 6.88199 4.08003 6.90009 4.06811 6.91916C3.9623 7.08152 3.90022 7.26846 3.88791 7.46187C3.87559 7.65528 3.91344 7.84859 3.99779 8.02306C4.63483 9.32595 5.94756 10.6288 7.26451 11.2652C7.44027 11.3487 7.6347 11.3853 7.8288 11.3712C8.0229 11.3572 8.21004 11.293 8.37193 11.185C8.38999 11.1729 8.40736 11.1597 8.42397 11.1456L10.1333 9.68736L13.4379 11.1674C13.4379 11.1674 13.4436 11.1674 13.4457 11.1674C13.3558 11.849 13.0206 12.4744 12.503 12.9267C11.9853 13.379 11.3206 13.6272 10.6332 13.6249Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
    {
      name: "Abondoned",
      number: "5",
      icon: (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.95539 0.6875C6.50911 0.6875 5.09531 1.11637 3.89278 1.91988C2.69024 2.72339 1.75298 3.86544 1.19952 5.20163C0.646052 6.53781 0.50124 8.00811 0.783394 9.4266C1.06555 10.8451 1.762 12.148 2.78467 13.1707C3.80734 14.1934 5.1103 14.8898 6.52879 15.172C7.94727 15.4541 9.41757 15.3093 10.7538 14.7559C12.0899 14.2024 13.232 13.2651 14.0355 12.0626C14.839 10.8601 15.2679 9.44628 15.2679 8C15.2658 6.06123 14.4948 4.20246 13.1238 2.83154C11.7529 1.46063 9.89415 0.689547 7.95539 0.6875ZM14.1429 8C14.1443 9.4467 13.6363 10.8477 12.7078 11.9572L3.9982 3.24688C4.90171 2.49522 6.00062 2.01644 7.16632 1.86655C8.33202 1.71667 9.5163 1.90189 10.5806 2.40054C11.6448 2.89919 12.5451 3.69064 13.176 4.68227C13.8068 5.6739 14.1422 6.8247 14.1429 8ZM1.76789 8C1.76645 6.5533 2.27452 5.15229 3.20296 4.04281L11.9126 12.7531C11.0091 13.5048 9.91015 13.9836 8.74445 14.1334C7.57875 14.2833 6.39447 14.0981 5.3302 13.5995C4.26592 13.1008 3.36568 12.3094 2.73482 11.3177C2.10395 10.3261 1.76856 9.1753 1.76789 8Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
    {
      name: "In Queue",
      number: "2",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8878 13.9062C13.817 12.0549 12.1668 10.7274 10.2409 10.0981C11.1935 9.53099 11.9336 8.66686 12.3476 7.63841C12.7616 6.60996 12.8265 5.47405 12.5324 4.40513C12.2383 3.33621 11.6015 2.39338 10.7197 1.72142C9.83791 1.04947 8.75992 0.685547 7.65128 0.685547C6.54264 0.685547 5.46466 1.04947 4.58286 1.72142C3.70107 2.39338 3.06423 3.33621 2.77015 4.40513C2.47606 5.47405 2.54099 6.60996 2.95496 7.63841C3.36893 8.66686 4.10906 9.53099 5.06167 10.0981C3.13581 10.7267 1.48558 12.0542 0.41472 13.9062C0.37545 13.9702 0.349402 14.0415 0.338114 14.1158C0.326826 14.19 0.330526 14.2658 0.348995 14.3386C0.367465 14.4114 0.40033 14.4798 0.445652 14.5397C0.490974 14.5996 0.547834 14.6498 0.612879 14.6874C0.677923 14.7249 0.749833 14.7491 0.824367 14.7584C0.8989 14.7678 0.974547 14.7621 1.04684 14.7417C1.11914 14.7213 1.18663 14.6867 1.24531 14.6398C1.304 14.5929 1.3527 14.5347 1.38855 14.4687C2.71324 12.1793 5.05464 10.8125 7.65128 10.8125C10.2479 10.8125 12.5893 12.1793 13.914 14.4687C13.9499 14.5347 13.9986 14.5929 14.0573 14.6398C14.1159 14.6867 14.1834 14.7213 14.2557 14.7417C14.328 14.7621 14.4037 14.7678 14.4782 14.7584C14.5527 14.7491 14.6246 14.7249 14.6897 14.6874C14.7547 14.6498 14.8116 14.5996 14.8569 14.5397C14.9022 14.4798 14.9351 14.4114 14.9536 14.3386C14.972 14.2658 14.9757 14.19 14.9645 14.1158C14.9532 14.0415 14.9271 13.9702 14.8878 13.9062ZM3.71378 5.74996C3.71378 4.9712 3.94471 4.20992 4.37737 3.5624C4.81003 2.91488 5.42498 2.4102 6.14447 2.11218C6.86395 1.81416 7.65565 1.73619 8.41945 1.88812C9.18325 2.04005 9.88485 2.41506 10.4355 2.96573C10.9862 3.5164 11.3612 4.21799 11.5131 4.98179C11.6651 5.74559 11.5871 6.53729 11.2891 7.25678C10.991 7.97626 10.4864 8.59121 9.83884 9.02387C9.19132 9.45653 8.43005 9.68746 7.65128 9.68746C6.60734 9.68634 5.60647 9.27114 4.86828 8.53296C4.1301 7.79478 3.7149 6.79391 3.71378 5.74996Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
    {
      name: "Avg. Queue Time",
      number: "00:02:56",
      icon: (
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.34842 0.6875C5.90215 0.6875 4.48835 1.11637 3.28582 1.91988C2.08328 2.72339 1.14602 3.86544 0.592553 5.20163C0.0390876 6.53781 -0.105724 8.00811 0.17643 9.4266C0.458585 10.8451 1.15503 12.148 2.1777 13.1707C3.20038 14.1934 4.50334 14.8898 5.92182 15.172C7.34031 15.4541 8.81061 15.3093 10.1468 14.7559C11.483 14.2024 12.625 13.2651 13.4285 12.0626C14.2321 10.8601 14.6609 9.44628 14.6609 8C14.6589 6.06123 13.8878 4.20246 12.5169 2.83154C11.146 1.46063 9.28719 0.689547 7.34842 0.6875ZM7.34842 14.1875C6.12465 14.1875 4.92836 13.8246 3.91083 13.1447C2.8933 12.4648 2.10023 11.4985 1.63192 10.3679C1.1636 9.23724 1.04107 7.99314 1.27981 6.79288C1.51856 5.59262 2.10786 4.49011 2.9732 3.62478C3.83854 2.75944 4.94104 2.17014 6.1413 1.93139C7.34156 1.69264 8.58566 1.81518 9.71628 2.2835C10.8469 2.75181 11.8132 3.54488 12.4931 4.56241C13.173 5.57994 13.5359 6.77623 13.5359 8C13.5341 9.64046 12.8816 11.2132 11.7216 12.3732C10.5616 13.5331 8.98888 14.1856 7.34842 14.1875ZM11.8484 8C11.8484 8.14918 11.7892 8.29226 11.6837 8.39775C11.5782 8.50324 11.4351 8.5625 11.2859 8.5625H7.34842C7.19924 8.5625 7.05616 8.50324 6.95068 8.39775C6.84519 8.29226 6.78592 8.14918 6.78592 8V4.0625C6.78592 3.91332 6.84519 3.77024 6.95068 3.66475C7.05616 3.55926 7.19924 3.5 7.34842 3.5C7.49761 3.5 7.64068 3.55926 7.74617 3.66475C7.85166 3.77024 7.91092 3.91332 7.91092 4.0625V7.4375H11.2859C11.4351 7.4375 11.5782 7.49676 11.6837 7.60225C11.7892 7.70774 11.8484 7.85082 11.8484 8Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
    {
      name: "Max Queue Time",
      number: "00:03:56",
      icon: (
        <svg
          width="15"
          height="16"
          viewBox="0 0 15 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.34842 0.6875C5.90215 0.6875 4.48835 1.11637 3.28582 1.91988C2.08328 2.72339 1.14602 3.86544 0.592553 5.20163C0.0390876 6.53781 -0.105724 8.00811 0.17643 9.4266C0.458585 10.8451 1.15503 12.148 2.1777 13.1707C3.20038 14.1934 4.50334 14.8898 5.92182 15.172C7.34031 15.4541 8.81061 15.3093 10.1468 14.7559C11.483 14.2024 12.625 13.2651 13.4285 12.0626C14.2321 10.8601 14.6609 9.44628 14.6609 8C14.6589 6.06123 13.8878 4.20246 12.5169 2.83154C11.146 1.46063 9.28719 0.689547 7.34842 0.6875ZM7.34842 14.1875C6.12465 14.1875 4.92836 13.8246 3.91083 13.1447C2.8933 12.4648 2.10023 11.4985 1.63192 10.3679C1.1636 9.23724 1.04107 7.99314 1.27981 6.79288C1.51856 5.59262 2.10786 4.49011 2.9732 3.62478C3.83854 2.75944 4.94104 2.17014 6.1413 1.93139C7.34156 1.69264 8.58566 1.81518 9.71628 2.2835C10.8469 2.75181 11.8132 3.54488 12.4931 4.56241C13.173 5.57994 13.5359 6.77623 13.5359 8C13.5341 9.64046 12.8816 11.2132 11.7216 12.3732C10.5616 13.5331 8.98888 14.1856 7.34842 14.1875ZM11.8484 8C11.8484 8.14918 11.7892 8.29226 11.6837 8.39775C11.5782 8.50324 11.4351 8.5625 11.2859 8.5625H7.34842C7.19924 8.5625 7.05616 8.50324 6.95068 8.39775C6.84519 8.29226 6.78592 8.14918 6.78592 8V4.0625C6.78592 3.91332 6.84519 3.77024 6.95068 3.66475C7.05616 3.55926 7.19924 3.5 7.34842 3.5C7.49761 3.5 7.64068 3.55926 7.74617 3.66475C7.85166 3.77024 7.91092 3.91332 7.91092 4.0625V7.4375H11.2859C11.4351 7.4375 11.5782 7.49676 11.6837 7.60225C11.7892 7.70774 11.8484 7.85082 11.8484 8Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
    {
      name: "Service Level",
      number: "82%",
      icon: (
        <svg
          width="13"
          height="14"
          viewBox="0 0 13 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.55429 4.0625V13.0625C9.55429 13.2117 9.49503 13.3548 9.38954 13.4602C9.28405 13.5657 9.14097 13.625 8.99179 13.625C8.84261 13.625 8.69953 13.5657 8.59404 13.4602C8.48855 13.3548 8.42929 13.2117 8.42929 13.0625V4.0625C8.42929 3.91332 8.48855 3.77024 8.59404 3.66475C8.69953 3.55926 8.84261 3.5 8.99179 3.5C9.14097 3.5 9.28405 3.55926 9.38954 3.66475C9.49503 3.77024 9.55429 3.91332 9.55429 4.0625ZM11.8043 0.6875C11.6551 0.6875 11.512 0.746763 11.4065 0.852252C11.3011 0.957742 11.2418 1.10082 11.2418 1.25V13.0625C11.2418 13.2117 11.3011 13.3548 11.4065 13.4602C11.512 13.5657 11.6551 13.625 11.8043 13.625C11.9535 13.625 12.0965 13.5657 12.202 13.4602C12.3075 13.3548 12.3668 13.2117 12.3668 13.0625V1.25C12.3668 1.10082 12.3075 0.957742 12.202 0.852252C12.0965 0.746763 11.9535 0.6875 11.8043 0.6875ZM6.17929 6.3125C6.03011 6.3125 5.88703 6.37176 5.78154 6.47725C5.67605 6.58274 5.61679 6.72582 5.61679 6.875V13.0625C5.61679 13.2117 5.67605 13.3548 5.78154 13.4602C5.88703 13.5657 6.03011 13.625 6.17929 13.625C6.32847 13.625 6.47155 13.5657 6.57704 13.4602C6.68253 13.3548 6.74179 13.2117 6.74179 13.0625V6.875C6.74179 6.72582 6.68253 6.58274 6.57704 6.47725C6.47155 6.37176 6.32847 6.3125 6.17929 6.3125ZM3.36679 9.125C3.21761 9.125 3.07453 9.18426 2.96904 9.28975C2.86355 9.39524 2.80429 9.53832 2.80429 9.6875V13.0625C2.80429 13.2117 2.86355 13.3548 2.96904 13.4602C3.07453 13.5657 3.21761 13.625 3.36679 13.625C3.51597 13.625 3.65905 13.5657 3.76454 13.4602C3.87003 13.3548 3.92929 13.2117 3.92929 13.0625V9.6875C3.92929 9.53832 3.87003 9.39524 3.76454 9.28975C3.65905 9.18426 3.51597 9.125 3.36679 9.125ZM0.554291 11.9375C0.405106 11.9375 0.262033 11.9968 0.156543 12.1023C0.0510541 12.2077 -0.00820923 12.3508 -0.00820923 12.5V13.0625C-0.00820923 13.2117 0.0510541 13.3548 0.156543 13.4602C0.262033 13.5657 0.405106 13.625 0.554291 13.625C0.703475 13.625 0.846549 13.5657 0.952038 13.4602C1.05753 13.3548 1.11679 13.2117 1.11679 13.0625V12.5C1.11679 12.3508 1.05753 12.2077 0.952038 12.1023C0.846549 11.9968 0.703475 11.9375 0.554291 11.9375Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
  ];

  const agentStatus = [
    {
      name: "Agents",
      number: "28",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.8878 13.9062C13.817 12.0549 12.1668 10.7274 10.2409 10.0981C11.1935 9.53099 11.9336 8.66686 12.3476 7.63841C12.7616 6.60996 12.8265 5.47405 12.5324 4.40513C12.2383 3.33621 11.6015 2.39338 10.7197 1.72142C9.83791 1.04947 8.75992 0.685547 7.65128 0.685547C6.54264 0.685547 5.46466 1.04947 4.58286 1.72142C3.70107 2.39338 3.06423 3.33621 2.77015 4.40513C2.47606 5.47405 2.54099 6.60996 2.95496 7.63841C3.36893 8.66686 4.10906 9.53099 5.06167 10.0981C3.13581 10.7267 1.48558 12.0542 0.41472 13.9062C0.37545 13.9702 0.349402 14.0415 0.338114 14.1158C0.326826 14.19 0.330526 14.2658 0.348995 14.3386C0.367465 14.4114 0.40033 14.4798 0.445652 14.5397C0.490974 14.5996 0.547834 14.6498 0.612879 14.6874C0.677923 14.7249 0.749833 14.7491 0.824367 14.7584C0.8989 14.7678 0.974547 14.7621 1.04684 14.7417C1.11914 14.7213 1.18663 14.6867 1.24531 14.6398C1.304 14.5929 1.3527 14.5347 1.38855 14.4687C2.71324 12.1793 5.05464 10.8125 7.65128 10.8125C10.2479 10.8125 12.5893 12.1793 13.914 14.4687C13.9499 14.5347 13.9986 14.5929 14.0573 14.6398C14.1159 14.6867 14.1834 14.7213 14.2557 14.7417C14.328 14.7621 14.4037 14.7678 14.4782 14.7584C14.5527 14.7491 14.6246 14.7249 14.6897 14.6874C14.7547 14.6498 14.8116 14.5996 14.8569 14.5397C14.9022 14.4798 14.9351 14.4114 14.9536 14.3386C14.972 14.2658 14.9757 14.19 14.9645 14.1158C14.9532 14.0415 14.9271 13.9702 14.8878 13.9062ZM3.71378 5.74996C3.71378 4.9712 3.94471 4.20992 4.37737 3.5624C4.81003 2.91488 5.42498 2.4102 6.14447 2.11218C6.86395 1.81416 7.65565 1.73619 8.41945 1.88812C9.18325 2.04005 9.88485 2.41506 10.4355 2.96573C10.9862 3.5164 11.3612 4.21799 11.5131 4.98179C11.6651 5.74559 11.5871 6.53729 11.2891 7.25678C10.991 7.97626 10.4864 8.59121 9.83884 9.02387C9.19132 9.45653 8.43005 9.68746 7.65128 9.68746C6.60734 9.68634 5.60647 9.27114 4.86828 8.53296C4.1301 7.79478 3.7149 6.79391 3.71378 5.74996Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
    {
      name: "Logged in",
      number: "12",
      icon: (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.7302 6.796C15.7145 6.71679 15.682 6.64188 15.6348 6.57637C15.5876 6.51085 15.5268 6.45626 15.4567 6.41631L13.3592 5.221L13.3508 2.8571C13.3505 2.77568 13.3326 2.6953 13.2983 2.62149C13.2639 2.54768 13.2139 2.48221 13.1518 2.4296C12.391 1.78602 11.5148 1.29283 10.5699 0.976237C10.4955 0.951051 10.4167 0.94173 10.3384 0.948875C10.2602 0.95602 10.1843 0.979472 10.1157 1.01772L8.00001 2.20038L5.8822 1.01561C5.81354 0.977147 5.73758 0.953518 5.65921 0.946251C5.58085 0.938984 5.50184 0.948241 5.42728 0.973424C4.48296 1.29205 3.60776 1.78715 2.84821 2.43241C2.78618 2.48494 2.73626 2.5503 2.70191 2.62398C2.66756 2.69766 2.64959 2.77791 2.64923 2.85921L2.63868 5.22522L0.541262 6.42053C0.471091 6.46048 0.410343 6.51507 0.363147 6.58059C0.315951 6.6461 0.283414 6.72101 0.267746 6.80022C0.0757903 7.76483 0.0757903 8.7578 0.267746 9.72241C0.283414 9.80162 0.315951 9.87653 0.363147 9.94204C0.410343 10.0076 0.471091 10.0621 0.541262 10.1021L2.63868 11.2974L2.64712 13.662C2.64738 13.7434 2.6653 13.8238 2.69965 13.8976C2.73401 13.9714 2.78398 14.0369 2.84611 14.0895C3.60694 14.7331 4.48309 15.2263 5.42798 15.5429C5.50239 15.5681 5.58125 15.5774 5.65948 15.5702C5.73771 15.5631 5.81358 15.5396 5.8822 15.5014L8.00001 14.3152L10.1178 15.5C10.2016 15.5467 10.2961 15.5709 10.392 15.5703C10.4535 15.5703 10.5145 15.5603 10.5727 15.5408C11.5168 15.2223 12.392 14.7277 13.1518 14.0832C13.2138 14.0307 13.2638 13.9653 13.2981 13.8916C13.3325 13.8179 13.3504 13.7377 13.3508 13.6564L13.3613 11.2904L15.4588 10.0951C15.5289 10.0551 15.5897 10.0005 15.6369 9.93501C15.6841 9.8695 15.7166 9.79459 15.7323 9.71538C15.9232 8.75154 15.9224 7.75956 15.7302 6.796ZM8.00001 11.0703C7.44375 11.0703 6.89998 10.9053 6.43747 10.5963C5.97496 10.2873 5.61447 9.84801 5.4016 9.3341C5.18873 8.82018 5.13303 8.25468 5.24155 7.70911C5.35007 7.16354 5.61794 6.6624 6.01127 6.26906C6.40461 5.87573 6.90575 5.60786 7.45132 5.49934C7.99689 5.39082 8.56239 5.44652 9.07631 5.65939C9.59023 5.87226 10.0295 6.23274 10.3385 6.69526C10.6476 7.15777 10.8125 7.70154 10.8125 8.2578C10.8125 9.00372 10.5162 9.71909 9.98875 10.2465C9.4613 10.774 8.74593 11.0703 8.00001 11.0703Z"
            fill="#6D81CE"
          />
        </svg>
      ),
    },
    {
      name: "On Phone",
      number: "4",
      icon: (
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.8936 10.1416L10.5812 8.65728L10.572 8.65306C10.4001 8.57951 10.2125 8.55 10.0262 8.56718C9.83998 8.58437 9.66097 8.64772 9.50537 8.7515C9.48705 8.7636 9.46944 8.77675 9.45264 8.79087L7.74123 10.2499C6.65701 9.72322 5.53764 8.61228 5.011 7.54212L6.47209 5.8047C6.48615 5.78712 6.49951 5.76955 6.51217 5.75056C6.61372 5.59538 6.67533 5.41751 6.69153 5.23276C6.70772 5.04802 6.67799 4.86213 6.60498 4.69165V4.68322L5.11647 1.36517C5.01995 1.14247 4.85401 0.956946 4.64339 0.836307C4.43278 0.715667 4.1888 0.666377 3.94787 0.695795C2.99512 0.821167 2.12058 1.28907 1.48759 2.01211C0.854606 2.73515 0.506462 3.66389 0.508185 4.62486C0.508185 10.2077 5.05037 14.7499 10.6332 14.7499C11.5942 14.7516 12.5229 14.4034 13.2459 13.7705C13.969 13.1375 14.4369 12.2629 14.5622 11.3102C14.5917 11.0693 14.5425 10.8254 14.422 10.6148C14.3015 10.4042 14.1161 10.2382 13.8936 10.1416ZM10.6332 13.6249C8.24704 13.6223 5.95936 12.6732 4.2721 10.9859C2.58484 9.29868 1.63579 7.01101 1.63318 4.62486C1.63054 3.93825 1.87791 3.27415 2.32909 2.75659C2.78028 2.23903 3.40443 1.90339 4.08498 1.81236C4.0847 1.81516 4.0847 1.81799 4.08498 1.8208L5.56154 5.12548L4.10818 6.86501C4.09343 6.88199 4.08003 6.90009 4.06811 6.91916C3.9623 7.08152 3.90022 7.26846 3.88791 7.46187C3.87559 7.65528 3.91344 7.84859 3.99779 8.02306C4.63483 9.32595 5.94756 10.6288 7.26451 11.2652C7.44027 11.3487 7.6347 11.3853 7.8288 11.3712C8.0229 11.3572 8.21004 11.293 8.37193 11.185C8.38999 11.1729 8.40736 11.1597 8.42397 11.1456L10.1333 9.68736L13.4379 11.1674C13.4379 11.1674 13.4436 11.1674 13.4457 11.1674C13.3558 11.849 13.0206 12.4744 12.503 12.9267C11.9853 13.379 11.3206 13.6272 10.6332 13.6249Z"
            fill="#2E4BB9"
          />
        </svg>
      ),
    },
  ];
  return (
    <div className="ml-[-12px] h-full">
      <div className="pt-3 px-3">
        <div className="bg-[white] h-[60px] p-2 rounded-lg">
          <TableTopBar
            hideDropdownValues={widgetList}
            setHideDropdownValues={setWidgetList}
            title={"Dashboard"}
          />
        </div>
      </div>
      <div className="h-[calc(100vh-184px)] w-[calc(100vw-103px)] overflow-auto items-end">
        <ResponsiveReactGridLayout
          // {...props}
          //#f0f0f0
          layouts={layouts}
          measureBeforeMount={false}
          useCSSTransforms={true}
          // compactType={compactType}
          // preventCollision={!compactType}
          // onLayoutChange={onLayoutChange}
          // onBreakpointChange={onBreakpointChange}
          // onDrop={onDrop}
          isDroppable
          margin={[12, 12]}
          isDraggable={drag}
          isResizable={drag}
          cols={{ lg: 5, md: 2, sm: 1, xs: 1, xxs: 1 }}
          rowHeight={80} /*322*/
          draggableHandle=".drag-handle"
          autoSize={true}
        >
          {generateDOM()}
        </ResponsiveReactGridLayout>
      </div>
    </div>
  );
}
export default Dashboard;
